var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`type-box font-${_vm.font} ${_vm.type}`},[_vm._v("\n  "+_vm._s(_vm.words)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }